(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bk"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
  }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
  }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["region-list"] && !Shopify.designMode) return;
  try {
    
class RegionListCountdown extends HTMLElement {
  constructor() {
    super();
    this._interval = null;
  }

  connectedCallback() {
    const targetDateStr = this.dataset.targetDate || '';
    const targetTimeStr = this.dataset.targetTime || '00:00';
    
    if (targetDateStr) {
      // Use slashes for safer cross-browser parsing (e.g. "2026/03/20 13:00:00")
      const targetStr = `${targetDateStr.replace(/-/g, '/')} ${targetTimeStr}:00`;
      this._targetTimeMs = new Date(targetStr).getTime();
    } else {
      this._targetTimeMs = NaN;
    }

    this._elDays = this.querySelector('[data-countdown-days]');
    this._elHrs  = this.querySelector('[data-countdown-hrs]');
    this._elMins = this.querySelector('[data-countdown-mins]');
    this._elSecs = this.querySelector('[data-countdown-secs]');

    if (!isNaN(this._targetTimeMs)) {
      this._tick();
      this._interval = setInterval(() => this._tick(), 1000);
    }
  }

  disconnectedCallback() {
    if (this._interval) {
      clearInterval(this._interval);
    }
  }

  _tick() {
    const nowMs = new Date().getTime();
    let remainingMs = this._targetTimeMs - nowMs;

    if (remainingMs <= 0) {
      if (this._interval) clearInterval(this._interval);
      remainingMs = 0;
    }

    const totalSecs = Math.floor(remainingMs / 1000);
    const days = Math.floor(totalSecs / 86400);
    const hrs  = Math.floor((totalSecs % 86400) / 3600);
    const mins = Math.floor((totalSecs % 3600) / 60);
    const secs = totalSecs % 60;

    const pad = (n) => String(n).padStart(2, '0');

    if (this._elDays) this._elDays.textContent = pad(days);
    if (this._elHrs)  this._elHrs.textContent  = pad(hrs);
    if (this._elMins) this._elMins.textContent  = pad(mins);
    if (this._elSecs) this._elSecs.textContent  = pad(secs);
  }
}

if (!customElements.get('region-list-countdown')) {
  customElements.define('region-list-countdown', RegionListCountdown);
}

class RegionListAnchor extends HTMLElement {
  connectedCallback() {
    // Init anchors inside this section
    this._initAnchors();

    // Handle scroll-to on page load (in case we landed via ?scroll_to=)
    this._handleScrollParam();
  }

  _formatSelector(raw) {
    if (!raw) return null;
    return (raw.startsWith('#') || raw.startsWith('.')) ? raw : '#' + raw;
  }

  _scrollToElement(el) {
    const header = document.querySelector('store-header') || document.querySelector('.header') || document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const top = el.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: Math.max(0, top - headerHeight), behavior: 'smooth' });
  }

  _handleScrollParam() {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('scroll_to');
    const selector = this._formatSelector(raw);
    if (!selector) return;

    setTimeout(() => {
      try {
        const target = document.querySelector(selector);
        if (target) {
          this._scrollToElement(target);
          const url = new URL(window.location.href);
          url.searchParams.delete('scroll_to');
          window.history.replaceState({}, document.title, url.toString());
        }
      } catch (e) {
        console.warn('[RegionListAnchor] scroll_to error:', e);
      }
    }, 500);
  }

  _initAnchors() {
    this.querySelectorAll('.js-custom-anchor').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const raw = anchor.getAttribute('data-target');
        const selector = this._formatSelector(raw);
        if (!selector) return;

        e.preventDefault();

        const anchorUrl  = new URL(anchor.href, window.location.origin);
        const currentUrl = new URL(window.location.href);

        if (anchorUrl.pathname === currentUrl.pathname) {
          try {
            const target = document.querySelector(selector);
            if (target) {
              this._scrollToElement(target);
            } else {
              window.location.href = anchor.href;
            }
          } catch (err) {
            window.location.href = anchor.href;
          }
        } else {
          anchorUrl.searchParams.set('scroll_to', raw);
          window.location.href = anchorUrl.toString();
        }
      });
    });
  }
}

if (!customElements.get('region-list-anchor')) {
  customElements.define('region-list-anchor', RegionListAnchor);

  // Attach to each section wrapper after DOM is ready
  const init = () => {
    document.querySelectorAll('.rl-section').forEach((section) => {
      if (section.querySelector('.js-custom-anchor') && !section.__rlAnchorInit) {
        const anchor = new RegionListAnchor();
        section.__rlAnchorInit = true;
        // Piggy-back init on the element itself
        Object.assign(anchor, { querySelectorAll: (s) => section.querySelectorAll(s) });
        anchor._initAnchors.call({ querySelectorAll: (s) => section.querySelectorAll(s), _formatSelector: anchor._formatSelector, _scrollToElement: anchor._scrollToElement });
        anchor._handleScrollParam.call(anchor);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

  } catch(e) { console.error(e); }
})();
})();
